/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum NftPurchaseStatus {
    CART = 'CART',
    PAYMENT = 'PAYMENT',
    ERRORPAYMENT = 'ERROR_PAYMENT',
    PROCESSING = 'PROCESSING',
    MINTED = 'MINTED',
    FULLERRORMINTING = 'FULL_ERROR_MINTING',
    PARTIALERRORMINTING = 'PARTIAL_ERROR_MINTING'
}

export function NftPurchaseStatusFromJSON(json: any): NftPurchaseStatus {
    return NftPurchaseStatusFromJSONTyped(json, false);
}

export function NftPurchaseStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftPurchaseStatus {
    return json as NftPurchaseStatus;
}

export function NftPurchaseStatusToJSON(value?: NftPurchaseStatus | null): any {
    return value as any;
}

